import React from 'react';

import * as ConfigParamService from '../../../services/config/admin/ConfigParam';

const ConfigParamContext = React.createContext();
const { Provider, Consumer } = ConfigParamContext;

class ConfigParamProvider extends React.Component {
  state = {
    response: null,
  };

  constructor(props) {
    super(props);
    this.home = this.home.bind(this);
    this.addParam = this.addParam.bind(this);
    this.editParam = this.editParam.bind(this);
    this.updateParam = this.updateParam.bind(this);
    this.updateParamValue = this.updateParamValue.bind(this);
    this.deleteParam = this.deleteParam.bind(this);
    this.dashboard = this.dashboard.bind(this);
  }

  async home(data) {
    return new Promise(async (resolve, reject) => {
      await ConfigParamService.home(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async addParam(data) {
    return new Promise(async (resolve, reject) => {
      await ConfigParamService.addParam(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async editParam(id) {
    return new Promise(async (resolve, reject) => {
      await ConfigParamService.editParam(id)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async updateParam(data) {
    return new Promise(async (resolve, reject) => {
      await ConfigParamService.updateParam(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async updateParamValue(data) {
    return new Promise(async (resolve, reject) => {
      await ConfigParamService.updateParamValue(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async deleteParam(data) {
    return new Promise(async (resolve, reject) => {
      await ConfigParamService.deleteParam(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async dashboard(data) {
    return new Promise(async (resolve, reject) => {
      await ConfigParamService.dashboard(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  render() {
    const { children } = this.props;

    return (
      <Provider
        value={{
          response: this.state.response,
          home: this.home,
          addParam: this.addParam,
          editParam: this.editParam,
          updateParam: this.updateParam,
          updateParamValue: this.updateParamValue,
          deleteParam: this.deleteParam,
          dashboard: this.dashboard,
        }}
      >
        {children}
      </Provider>
    );
  }
}

export default ConfigParamContext;

export { ConfigParamProvider, Consumer };
